export const CREATE_CERTIFICATE_TIERS = 'createCertificateTiers';
export const PAGE_SETTINGS = 'pageSettings';
export const CREATE_CAMPAIGN_DETAILS = 'createCampaign';
export const EDIT_PROFILE = 'editProfile';
export const RESEND_CERTIFICATES = 'resendCertificates';
export const NEW_BUY_PAGE = 'newBuyPage';
export const CREATE_CERTIFICATE = 'createCertificate';
